import React from "react";
import "../VideoModal.css";

const VideoModal = ({ video, onClose }) => {
  // Helper function to convert YouTube links to embed URL
  const getYouTubeEmbedUrl = (url) => {
    let videoId = "";

    try {
      const urlObj = new URL(url);

      if (urlObj.hostname.includes("youtu.be")) {
        // short URL: youtu.be/VIDEOID
        videoId = urlObj.pathname.slice(1); // remove leading "/"
      } else if (urlObj.hostname.includes("youtube.com")) {
        // regular URL: youtube.com/watch?v=VIDEOID
        videoId = urlObj.searchParams.get("v");
      }
    } catch (error) {
      console.error("Invalid URL:", url);
      return null;
    }

    if (!videoId) return null;
    return `https://www.youtube.com/embed/${videoId}?autoplay=1`;
  };

  const isYouTube = video.url.includes("youtu");
  const embedUrl = isYouTube ? getYouTubeEmbedUrl(video.url) : null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="close-btn" onClick={onClose}>
          ✕
        </button>
        <h3>{video.title}</h3>

        {isYouTube && embedUrl ? (
          <iframe
            width="100%"
            height="480"
            src={embedUrl}
            title={video.title}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        ) : (
          <video width="100%" height="480" controls autoPlay>
            <source src={video.url} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        )}
      </div>
    </div>
  );
};

export default VideoModal;
